<template>
  <div id="app">
    <header class="navbar m-2">
      <section class="navbar-section">
        <img class="navbar-logo" alt="Logo" src="@/assets/logo-kigun.svg">
<!--        <a href="#" class="navbar-brand mr-2">kigun</a>-->
<!--        <a href="#" class="btn btn-link">Perio chart</a>-->
        <a href="#" class="btn btn-link">Smile Design</a>
      </section>
      <section class="navbar-section">
        &copy; Mihai Tarce
      </section>
    </header>

    <SmileDesign />
  </div>
</template>

<script>
import SmileDesign from '@/components/smile/SmileDesign.vue'
// import PerioChart from '@/components/periochart/PerioChart.vue'

export default {
  name: 'app',
  components: {
    // PerioChart,
    SmileDesign
  },
  created() {
    this.$store.commit('startMachine')
  }
}
</script>

<style lang="scss">
@import '~spectre.css/src/spectre.scss';
@import '~spectre.css/src/spectre-icons.scss';
@import '~spectre.css/src/spectre-exp.scss';

/*#app {*/
/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/

.navbar-logo {
  height: 36px;
  margin: 0 0.5rem;
}
</style>
